// Host requirements, version 2026-11-02 (venue-search ledger VS1.2).
// A host confirms these 4 statements before listing a venue. VS1.3 stores the
// version they confirmed with each venue.
// Never edit a released version. To change a statement, add a new file with a
// new date and point CURRENT_HOST_REQUIREMENTS in ./index.js at it
// (hostRequirements.test.js fails if a released file changes).

const requirements = {
  version: '2026-11-02',
  statements: [
    {
      id: 'vendors',
      text: 'Bookers may hire any vendors they want. I will not require a list of approved vendors.'
    },
    {
      id: 'eventsAllowed',
      text: 'My HOA, my city, and any lease or insurance allow events at this property, at the guest count I will list.'
    },
    {
      id: 'rightToList',
      text: 'I own this property, or I have the right to list it and sign for it.'
    },
    {
      id: 'accurate',
      text: 'My photos and details will be true, and I will keep them up to date.'
    }
  ]
};

export default requirements;
